import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Translate } from 'react-localize-redux';
import { CARD_STATES, SENTIMENTS, TRANSLATION_KEY } from '../constants';
import { monitorShape } from '../propShapes';
import { getDisplayVerdict } from '../utils';
import css from './SummaryChips.css';

const CHIPS = [
    { key: 'HEADS_UP', testId: 'summary-heads-up', dotClass: 'dotRed', matches: verdict => verdict?.sentiment === SENTIMENTS.HEADS_UP },
    { key: 'GOOD_NEWS', testId: 'summary-good-news', dotClass: 'dotGreen', matches: verdict => verdict?.sentiment === SENTIMENTS.GOOD_NEWS },
    { key: 'FLAGGED', testId: 'summary-flagged', dotClass: 'dotGray', matches: verdict => verdict?.should_notify === true },
    { key: 'PROMPT_UNCLEAR', testId: 'summary-needs-reply', dotClass: 'dotBlue', matches: verdict => verdict?.sentiment === SENTIMENTS.PROMPT_UNCLEAR },
];

const countMatching = (monitors, cardStates, liveRuns, chip) =>
    monitors.filter(monitor => {
        const state = cardStates.get(monitor.monitor_id);
        const countable =
            state === CARD_STATES.VERDICT ||
            state === CARD_STATES.BUSY ||
            (state === CARD_STATES.PAUSED && chip.key === 'PROMPT_UNCLEAR');
        if (!countable) return false;
        return chip.matches(getDisplayVerdict(monitor, liveRuns[monitor.session_id]));
    }).length;

const SummaryChips = ({ monitors, cardStates, liveRuns }) => (
    <div className={css.summaryChips}>
        {CHIPS.map(chip => {
            const count = countMatching(monitors, cardStates, liveRuns, chip);
            if (count === 0) return null;
            return (
                <span key={chip.key} data-testid={chip.testId} className={css.summaryChip}>
                    <span className={classNames(css.dot, css[chip.dotClass])} />
                    <Translate id={`${TRANSLATION_KEY}.SUMMARY.${chip.key}`} data={{ count }} />
                </span>
            );
        })}
    </div>
);

SummaryChips.propTypes = {
    monitors: PropTypes.arrayOf(monitorShape).isRequired,
    cardStates: PropTypes.instanceOf(Map).isRequired,
    liveRuns: PropTypes.objectOf(PropTypes.object).isRequired,
};

export default React.memo(SummaryChips);
